import React from 'react';
import { MapPinIcon } from '@heroicons/react/24/outline';

interface EventWhereProps {
  location: string | null | undefined;
}

const isUrl = (s: string): boolean => /^https?:\/\//i.test(s);

const EventWhere: React.FC<EventWhereProps> = ({ location }) => {
  if (!location) return null;
  return (
    <div className="flex items-start gap-3">
      <MapPinIcon className="w-5 h-5 text-text-tertiary mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0 text-sm text-text-primary break-words">
        {isUrl(location) ? (
          <a
            href={location}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-500 hover:underline break-all"
          >
            {location}
          </a>
        ) : (
          location
        )}
      </div>
    </div>
  );
};

export default EventWhere;
